// src/components/Header.js
import React from "react";
import "../cstm.style.css";

const Header = ({ title = "UTC Finance Dashboard", userName = "John Doe" }) => {
  const initial = userName ? userName.charAt(0).toUpperCase() : "U";

  return (
    <header className="header-container">
      <div className="header-left">
        <h1 className="header-title">{title}</h1>
      </div>

      <div className="header-right">
        {/* Placeholder for future icons / actions */}
        {/* <button className="header-icon-btn">🔍</button> */}
        {/* <button className="header-icon-btn">🔔</button> */}

        <div className="header-user">
          <span className="header-username">{userName}</span>
          <div className="header-avatar">{initial}</div>
        </div>
      </div>
    </header>
  );
};

export default Header;
